import { matricesByGameId } from '../constants/enumsByGames';
import { gameConfigurationStore } from '../gameModule/store/gameConfigurationStore';

export const handleSymbolAnimationPositionInMatrix = (winsMatrix) => {
  const winLines = [];
  let winLine;
  const { WinningLinesCoordinate, allLineMatrix, symbolsMatrix } = matricesByGameId[gameConfigurationStore.gameId]

  const allLinesMatrix = JSON.parse(JSON.stringify(allLineMatrix));
  winsMatrix.forEach((el) => {
    const activeSymbolsMatrix = JSON.parse(JSON.stringify(symbolsMatrix));
    let winElCount = 0;
    const isFromRight = el.line > 10;
    const lineIndex = el.line - (isFromRight ? 11 : 1);
    for (let i = isFromRight ? 4 : 0; isFromRight ? i >= 0 : i < 5; i += isFromRight ? -1 : 1) {
      const line = WinningLinesCoordinate[lineIndex][i];
      const row = line.x;
      const coll = line.y;
      if (winElCount < el.count) {
        winElCount += 1;
        activeSymbolsMatrix[row][coll] = 1;
        allLinesMatrix[row][coll] = 1;
      } else {
        activeSymbolsMatrix[row][coll] = 2;
        allLinesMatrix[row][coll] = allLinesMatrix[row][coll] ? allLinesMatrix[row][coll] : 2;
      }
    }

    winLine = {
      count: el.count,
      lines: activeSymbolsMatrix,
      win: el.lineWinAmount,
      winCard: el.symbol,
      line: el.line,
      symbol: el.symbol,
      allLines: allLinesMatrix,
    };
    winLines.push(winLine);
  });

  return { winLines, allLinesMatrix };
};
